import { createStyles, makeStyles } from "@mui/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { OLModal } from "./OLModal";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    errorInfo: {
      color: theme.red500,
      fontSize: "14px",
      marginBottom: theme.spacing(5),
    },
  }),
);

interface Props {
  action: () => void;
  cancelText?: string;
  close: () => void;
  additionalCloseAction?: () => void;
  "data-test-id"?: string;
  errorInfo?: string | React.ReactElement;
  header: string | JSX.Element;
  info?: string | JSX.Element;
  modalWidth?: number;
  open: boolean;
  submitText?: string;
  className?: string;
  isSubmitDisabled?: boolean;
}

export function ConfirmationModal({
  action,
  cancelText,
  close,
  additionalCloseAction,
  "data-test-id": dataTestId,
  errorInfo,
  header,
  info,
  modalWidth,
  open,
  submitText,
  className,
  isSubmitDisabled,
}: Props) {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <OLModal
      additionalCloseAction={additionalCloseAction}
      cancelText={message({ id: cancelText })}
      data-test-id={dataTestId}
      header={typeof header === "string" ? message({ id: header }) : header}
      modalWidth={modalWidth}
      onClose={close}
      open={open}
      submitAction={action}
      submitText={message({ id: submitText || "yes" })}
      className={className}
      submitDisabled={isSubmitDisabled}
    >
      <>
        {errorInfo && <span className={classes.errorInfo}>{errorInfo}</span>}
        {typeof info === "string" ? message({ id: info }) : <>{info}</>}
      </>
    </OLModal>
  );
}
